$(document).ready(function () {
    const isPWA = window.matchMedia('(display-mode: standalone)').matches;

    const platform = $.cookie('pwaPlatform');

    if (isPWA && platform === null) {
        $.ajax({
            type: 'post',
            url: '/site/pwa-cookie',
        });
    }

    if (!isPWA && platform !== null) {
        $.ajax({
            type: 'post',
            data: {
                remove: true,
            },
            url: '/site/pwa-cookie',
        });
    }
});
